import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-one-dual-view",
  templateUrl: "./axle-one-dual-view.component.html",
  styleUrls: ["./axle-one-dual-view.component.scss"],
})
export class AxleOneDualViewComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() veiculoId: number;

  public sensorOneIntLeftSelect: any = [];
  public sensorOneIntRightSelect: any = [];

  public sensorOneExtLeftSelect: any = [];
  public sensorOneExtRightSelect: any = [];

  public sensorOneIntRightCombo: any = [];
  public sensorOneIntLeftCombo: any = [];

  public sensorOneExtRightCombo: any = [];
  public sensorOneExtLeftCombo: any = [];

  public axisOneDoubleLeftIntForm: FormGroup;
  public axisOneDoubleLeftExtForm: FormGroup;

  public axisOneDoubleRightIntForm: FormGroup;
  public axisOneDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.axisOneDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisOneDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 ESQ INT"
      );
      this.axisOneDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 ESQ EXT"
      );

      this.axisOneDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 DIR INT"
      );
      this.axisOneDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo1DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          4
        );
        const eixo1EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          3
        );
        const eixo1DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          20
        );
        const eixo1EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          19
        );

        // EIXO 1 DIREITO EXTERNO
        if (eixo1DireitoExt != null) {
          this.axisOneDoubleRightExtForm.controls["id"].setValue(
            eixo1DireitoExt.id
          );

          if (eixo1DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorOneExtRightCombo, eixo1DireitoExt.sensor);
            this.sensorOneExtRightSelect = eixo1DireitoExt.sensor.id;
          }

          if (eixo1DireitoExt.pneu != null) {
            this.axisOneDoubleRightExtForm.controls["pneu"].setValue(
              eixo1DireitoExt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo1DireitoExt.nrPressaoMinima
          );

          this.axisOneDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo1DireitoExt.nrPressaoMaxima
          );

          this.axisOneDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 1 ESQ EXT
        if (eixo1EsquerdoExt != null) {
          this.axisOneDoubleLeftExtForm.controls["id"].setValue(
            eixo1EsquerdoExt.id
          );

          if (eixo1EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorOneExtLeftCombo, eixo1EsquerdoExt.sensor);
            this.sensorOneExtLeftSelect = eixo1EsquerdoExt.sensor.id;
          }

          if (eixo1EsquerdoExt.pneu != null) {
            this.axisOneDoubleLeftExtForm.controls["pneu"].setValue(
              eixo1EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo1EsquerdoExt.nrPressaoMinima
          );

          this.axisOneDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo1EsquerdoExt.nrPressaoMaxima
          );

          this.axisOneDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 1 DIREITO INTERNO
        if (eixo1DireitoInt != null) {
          this.axisOneDoubleRightIntForm.controls["id"].setValue(
            eixo1DireitoInt.id
          );

          if (eixo1DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorOneIntRightCombo, eixo1DireitoInt.sensor);
            this.sensorOneIntRightSelect = eixo1DireitoInt.sensor.id;
          }

          if (eixo1DireitoInt.pneu != null) {
            this.axisOneDoubleRightIntForm.controls["pneu"].setValue(
              eixo1DireitoInt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo1DireitoInt.nrPressaoMinima
          );

          this.axisOneDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo1DireitoInt.nrPressaoMaxima
          );

          this.axisOneDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 1 ESQ INT
        if (eixo1EsquerdoInt != null) {
          this.axisOneDoubleLeftIntForm.controls["id"].setValue(
            eixo1EsquerdoInt.id
          );

          if (eixo1EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorOneIntLeftCombo, eixo1EsquerdoInt.sensor);
            this.sensorOneIntLeftSelect = eixo1EsquerdoInt.sensor.id;
          }

          if (eixo1EsquerdoInt.pneu != null) {
            this.axisOneDoubleLeftIntForm.controls["pneu"].setValue(
              eixo1EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo1EsquerdoInt.nrPressaoMinima
          );

          this.axisOneDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo1EsquerdoInt.nrPressaoMaxima
          );

          this.axisOneDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
